import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  fullscreen: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }
  clicktoggle(){
    this.fullscreen = !this.fullscreen
  }
}
